module.exports = __webpack_public_path__ + "static/media/idlepage-events.1aea6cc3.svg";